import(/* webpackMode: "eager", webpackExports: ["KlardaAdvertise"] */ "/opt/build/repo/src/app/details/KlardaAdvertise.tsx");
